<div class="viewport-1" [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>

  <!-- MAIN CONTAINER -->
  <div class="task-screen-element ctm-main-container">
    <!-- RESPONSE CONTAINER -->
    <div class="task-screen-element ctm-response-container"
      [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
      [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
      <div class="testType font-18">{{ interventionTaskService.testType() }}</div>
      <div class="timer-bar-container">
        <trial-timer-bar></trial-timer-bar>
        <button [class]="{ 'replayVideo-no-timerbar': hideTimer, 'replayVideo': !hideTimer, 'semi-transparent': disableAVButtons }" (click)="replayVideo()" [disabled]="disableAVButtons"></button>
      </div>
      <div class="ctm-parts-container">
        <div class="audio-controls-container find-the-picture-speaker-position">
          <button class="speaker"
            (click)="playTargetAudio()"
            [disabled]="disableAVButtons"
          ></button>
          <button class="snail-button" (click)="playTargetAudioSlowed()" [disabled]="disableAVButtons"></button>
        </div>
        <div class="ctm-areas">
          <div class="ctm-prefix-suffix-width" [style.visibility]="(prefixResponseOptions.length) ? 'visible' : 'hidden'">
            <div class="ctm-prefix-text">PREFIX</div>
            <div class="ctm-prefix-tile font-30" [style.border]="'3px solid ' + interventionTaskService.highlightColor()">
              {{ prefixTile }}
            </div>
            @if (prefixAttempts) {
              <button class="prefix-suffix-target-speaker-button" [class.semi-transparent]="disableAVButtons" (click)="playSpecifiedAudio(correctPrefixAudio)" [disabled]="disableAVButtons"></button>
            }
            <button class="ctm-remove-suffix-prefix" [class.fully-transparent]="!prefixTile" (click)="removeMorpheme('prefix')"></button>
          </div>
          <div class="ctm-root-word-width">
            <div class="ctm-base-root-text">BASE</div>
            <div class="ctm-root-word-area font-30">
              {{ rootWordTile }}
            </div>
            @if (prefixAttempts || suffixAttempts) {
              <button class="prefix-suffix-target-speaker-button"
                (click)="playSpecifiedAudio(correctBaseAudio)"
                [class.semi-transparent]="disableAVButtons"
                [disabled]="disableAVButtons"
              ></button>
            }
          </div>
          <div class="ctm-prefix-suffix-width" [style.visibility]="(suffixResponseOptions.length) ? 'visible' : 'hidden'">
            <div class="ctm-suffix-text">SUFFIX</div>
            <div class="ctm-suffix-tile font-30" [style.border]="'3px solid ' + interventionTaskService.highlightColor()">
              {{ suffixTile }}
            </div>
            @if (suffixAttempts) {
              <button class="prefix-suffix-target-speaker-button" [class.semi-transparent]="disableAVButtons" (click)="playSpecifiedAudio(correctSuffixAudio)" [disabled]="disableAVButtons"></button>
            }
            <button class="ctm-remove-suffix-prefix" [class.fully-transparent]="!suffixTile" (click)="removeMorpheme('suffix')"></button>
          </div>
        </div>
        @if (showSubmitButton) {
          <div class="ctm-star-container">
            <button class="ctm-star-submit"
              (click)="submitResponse('change')"
              [disabled]="disableSubmitButton"
              [class.semi-transparent]="disableSubmitButton">
            </button>
          </div>
        }
      </div>
      <div class="ctm-lower-container">
        <div class="ctm-prefixes-select-container" [style.visibility]="(prefixResponseOptions.length) ? 'visible' : 'hidden'">
          <div class="ctm-prefix-select-container-header">PREFIXES</div>
          <div class="ctm-space-around-column">
            @for (option of prefixResponseOptions; track option) {
              <div class="prefix-suffix-select-options-container">
                <button class="prefix-suffix-select-options-text font-30"
                  (click)="selectPrefixSuffix(option.index, 'prefix')"
                  [class.selected]="option.highlight"
                  [style.border-color]="interventionTaskService.highlightColor()"
                  [disabled]="disableResponseButtons"
                  >
                  {{ option.text }}
                </button>
                @if (prefixAttempts) {
                  <button class="prefix-suffix-speaker-button" [class.semi-transparent]="disableAVButtons" (click)="playSpecifiedAudio(option.audio!)" [disabled]="disableAVButtons"></button>
                }
                <button class="prefix-suffix-info-button" [class.semi-transparent]="disableAVButtons" (click)="playSpecifiedAudio(option.definition)" [disabled]="disableAVButtons"></button>
              </div>
            }
          </div>
        </div>
        <div class="ctm-base-root-select-container" [class.semi-transparent]="!baseWordResponseOptions.length || baseWordTrialComplete">
          <div class="ctm-base-root-select-container-header">BASE</div>
          <div class="ctm-space-around-column">
            @for (option of baseWordResponseOptions; track option) {
              <div class="prefix-suffix-select-options-container">
                <button class="base-root-select-options font-30"
                  (click)="selectBaseAndSubmit(option.index)"
                  [style.border-color]="interventionTaskService.highlightColor()"
                      [class]="{
                        'base-root-select-options-selected': option.highlight,
                        'fully-transparent': (currentTrial.morpheme !== 'base'),
                      }"
                  [disabled]="disableResponseButtons || (currentTrial.morpheme !== 'base')"
                  >
                  {{ option.text }}
                </button>
                @if (baseAttempts) {
                  <button class="prefix-suffix-speaker-button" [class.semi-transparent]="disableAVButtons" (click)="playSpecifiedAudio(option.audio!)" [disabled]="disableAVButtons"></button>
                }
              </div>
            }
          </div>
        </div>
        <div class="ctm-suffixes-select-container" [style.visibility]="(suffixResponseOptions.length) ? 'visible' : 'hidden'">
          <div class="ctm-suffix-select-container-header">SUFFIXES</div>
          <div class="ctm-space-around-column">
            @for (option of suffixResponseOptions; track option) {
              <div class="prefix-suffix-select-options-container">
                <button class="prefix-suffix-select-options-text font-30"
                  (click)="selectPrefixSuffix(option.index, 'suffix')"
                  [class.selected]="option.highlight"
                  [style.border-color]="interventionTaskService.highlightColor()"
                  [disabled]="disableResponseButtons"
                  >
                  {{ option.text }}
                </button>
                @if (suffixAttempts) {
                  <button class="prefix-suffix-speaker-button" [class.semi-transparent]="disableAVButtons" (click)="playSpecifiedAudio(option.audio!)" [disabled]="disableAVButtons"></button>
                }
                <button class="prefix-suffix-info-button" [class.semi-transparent]="disableAVButtons" (click)="playSpecifiedAudio(option.definition)" [disabled]="disableAVButtons"></button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- DICTIONARY CONTAINER -->
    <div class="task-screen-element ctm-dictionary-container"
      [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
      [class]="animationComplete ? 'taskShow' : 'taskHide'"
      >
      <div class="ctm-dictionary-sections" [class]="{ 'find' : this.currentTrial.morpheme === 'base', 'change': this.currentTrial.morpheme !== 'base' }">
        <div class="ctm-dictionary-top">
          <button class="ctm-dictionary-speaker-button"
            (click)="playDictionaryAudio('top')"
            [disabled]="disableAVButtons"
            [class.semi-transparent]="disableAVButtons"
          ></button>
          <div class="root-word-dictionary-top-left">
            <div class="root-word-top-dictionary-word font-20" [class.fully-transparent]="!correctBaseResponse">
              {{ correctBaseResponse ? correctBaseResponse!.text : '' }}
            </div>
            <div class="root-word-top-dictionary-definition font-20">
              @if (currentTrial['dictionary-list']) {
                <span>{{ currentTrial["dictionary-list"].dictionary[1]["#text"] }}</span>
              }
            </div>
          </div>

          @if (topDictionaryImageURL) {
            <div class="root-word-dictionary-top-right">
              <img src="{{ topDictionaryImageURL }}" class="root-word-bottom-image-placeholder"/>
            </div>
          }
        </div>
        <div class="ctm-dictionary-bottom">
          @if (currentTrial.morpheme !== 'base') {
            <button
              class="ctm-dictionary-speaker-button"
              [class.semi-transparent]="disableAVButtons"
              (click)="playDictionaryAudio('bottom')"
              [disabled]="disableAVButtons"
            ></button>
          }
          <div class="ctm-dictionary-bottom-left">
            @if (currentTrial.morpheme !== 'base') {
              <div class="root-word-top-dictionary-word font-20"
                [class.fully-transparent]="(suffixAttempts === 0 && prefixAttempts === 0 && !prefixSuffixResponseCorrect)"
                >
                @if (currentTrial['dictionary-list']) {
                  <span>{{ currentTrial["dictionary-list"].dictionary[2]["#text"] }}</span>
                }
              </div>
            }
            @if (currentTrial.morpheme !== 'base') {
              <div class="root-word-bottom-dictionary-definition font-20">
                @if (currentTrial['dictionary-list']) {
                  <span>{{ currentTrial["dictionary-list"].dictionary[3]["#text"] }}</span>
                }
              </div>
            }
          </div>
          @if (bottomDictionaryImageURL) {
            <div class="ctm-dictionary-bottom-right">
              <img src="{{ bottomDictionaryImageURL }}" class="root-word-bottom-image-placeholder"/>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
